import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "main-wrap"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "header-bg"
}, null, -1);
const _hoisted_4 = {
  class: "header-bar index-header-bar"
};
const _hoisted_5 = {
  class: "city"
};
const _hoisted_6 = {
  class: "button scan-button",
  style: {
    "display": "none"
  }
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "扫一扫", -1);
const _hoisted_8 = {
  key: 0,
  class: "weather-button"
};
const _hoisted_9 = {
  class: "mapContainer"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  id: "map"
}, null, -1);
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "map-button"
};
const _hoisted_13 = {
  key: 0,
  class: "button left-button"
};
const _hoisted_14 = {
  class: "bottom-wrap"
};
const _hoisted_15 = {
  class: "bottom-main"
};
const _hoisted_16 = {
  key: 0,
  class: "card-bold tip-info info"
};
const _hoisted_17 = {
  key: 1,
  class: "card-bold tip-info info"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-bold card-bg banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "/static/img/yh-banner.png"
})], -1);
const _hoisted_19 = {
  class: "card-bold call-form"
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
}, null, -1);
const _hoisted_21 = {
  class: "address start-address"
};
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
}, null, -1);
const _hoisted_23 = {
  class: "address end-address"
};
const _hoisted_24 = {
  key: 4,
  class: "card reserve-data"
};
const _hoisted_25 = {
  key: 5,
  class: "card menu-grid"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "copyright"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "©2025 杭州金桔子科技有限公司")], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_grid_item = _resolveComponent("van-grid-item");
  const _component_van_grid = _resolveComponent("van-grid");
  const _component_reserve_form = _resolveComponent("reserve-form");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_proxy_form = _resolveComponent("proxy-form");
  const _component_voice_form = _resolveComponent("voice-form");
  const _directive_height_animate = _resolveDirective("height-animate");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "button user-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goUserCenter && $options.goUserCenter(...args))
  }, [_createVNode(_component_van_icon, {
    name: "contact",
    color: "#ff9500"
  })]), _createElementVNode("div", {
    class: "city-select",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goSelectCity && $options.goSelectCity(...args))
  }, [_createElementVNode("div", _hoisted_5, _toDisplayString($setup.cityName), 1), $setup.multiCitySupport ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 0,
    name: require('@/assets/icon/arrow-down.svg'),
    color: "#333",
    size: "10px",
    style: {
      "margin-right": "6px"
    }
  }, null, 8, ["name"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_icon, {
    name: "scan",
    color: "#ff9500"
  }), _hoisted_7]), $setup.showWeather ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_van_icon, {
    name: $setup.cityWeatherIcon,
    color: "#333",
    size: "14"
  }, null, 8, ["name"]), _createElementVNode("span", null, _toDisplayString($setup.cityWeather), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("img", {
    class: "pin-img",
    src: require('@/assets/icon/map/map-pin-point.png')
  }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, [false ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_van_icon, {
    class: "security",
    name: require('@/assets/icon/security.svg')
  }, null, 8, ["name"])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "button right-button",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.getCurrentPosition && $options.getCurrentPosition(...args))
  }, [_createVNode(_component_van_icon, {
    name: require('@/assets/icon/map/aim.svg')
  }, null, 8, ["name"])])])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [$setup.isMorningRushHour && false ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_van_icon, {
    name: "warning",
    color: "orange"
  }), _createTextVNode(" 高峰时段（7:00-8:30）部分车型不参与呼叫 ")])) : _createCommentVNode("", true), $setup.isEveningRushHour && false ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_van_icon, {
    name: "warning",
    color: "orange"
  }), _createTextVNode(" 高峰时段（16:30-17:30）部分车型不参与呼叫 ")])) : _createCommentVNode("", true), $setup.hasWaitDispatchOrder ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "card-bold tip-info wait-dispatch",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goCalling && $options.goCalling(...args))
  }, [_createVNode(_component_van_loading, {
    size: "16"
  }), _createTextVNode(" 正在为您呼叫附近的司机... "), _createVNode(_component_van_icon, {
    class: "link",
    name: "arrow"
  })])) : _createCommentVNode("", true), $setup.waitPayOrderCount > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "card-bold tip-info warning",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.goWaitPayOrder && $options.goWaitPayOrder(...args))
  }, [_createVNode(_component_van_icon, {
    name: "warning",
    color: "#ff9500"
  }), _createTextVNode(" 您有 " + _toDisplayString($setup.waitPayOrderCount) + " 个待付款的行程，请及时付款 ", 1), _createVNode(_component_van_icon, {
    class: "link",
    name: "arrow"
  })])) : _createCommentVNode("", true), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createVNode(_component_van_cell_group, {
    border: false
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      class: "start-address-input",
      style: {
        "padding-right": "16px"
      },
      border: false,
      onClick: _cache[5] || (_cache[5] = $event => $options.goSelectAddress('start'))
    }, {
      icon: _withCtx(() => [_hoisted_20]),
      title: _withCtx(() => [_createElementVNode("div", _hoisted_21, _toDisplayString($setup.startAddress), 1)]),
      "right-icon": _withCtx(() => [_createVNode(_component_van_icon, {
        name: "arrow",
        color: "#555"
      })]),
      _: 1
    }), _createElementVNode("div", {
      class: "end-address-input",
      onClick: _cache[6] || (_cache[6] = $event => $options.goSelectAddress('end'))
    }, [_hoisted_22, _createElementVNode("div", _hoisted_23, _toDisplayString($setup.endAddress), 1)])]),
    _: 1
  })]), $setup.reserve ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_van_icon, {
    name: "underway-o"
  }), _createTextVNode(" 您将预约 "), _createElementVNode("strong", {
    onClick: _cache[7] || (_cache[7] = (...args) => $options.clickShowReserveForm && $options.clickShowReserveForm(...args))
  }, [$setup.reserveDay === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode(" 今天 ")], 64)) : _createCommentVNode("", true), $setup.reserveDay === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createTextVNode(" 明天 ")], 64)) : _createCommentVNode("", true), $setup.reserveDay === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createTextVNode(" 后天 ")], 64)) : _createCommentVNode("", true), _createTextVNode(" (" + _toDisplayString($options.CommonUtil.formatDay($setup.reserveDay, 'MM月DD日')) + ") " + _toDisplayString($setup.reserveTime[0]) + "时" + _toDisplayString($setup.reserveTime[1]) + "分 ", 1)]), _createTextVNode("出发 ")])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_van_grid, {
    border: false,
    "column-num": 5
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid_item, {
      class: "reserve",
      icon: require('@/assets/icon/menu/reserve.svg'),
      text: $setup.reserve ? '已选预约' : '预约',
      onClick: $options.clickShowReserveForm
    }, null, 8, ["icon", "text", "onClick"]), _createVNode(_component_van_grid_item, {
      class: "proxy",
      icon: require('@/assets/icon/menu/proxy-call.svg'),
      text: $setup.proxy ? '已选代叫' : '代叫',
      onClick: $options.clickShowProxyForm
    }, null, 8, ["icon", "text", "onClick"]), _createVNode(_component_van_grid_item, {
      class: "returnTrip",
      icon: require('@/assets/icon/menu/return-trip.svg'),
      text: "回城车",
      onClick: $options.goReturnTrip
    }, null, 8, ["icon", "onClick"]), _createVNode(_component_van_grid_item, {
      class: "designatedDriving",
      icon: require('@/assets/icon/menu/designated-driving.svg'),
      text: "找代驾",
      onClick: $options.goDesignatedDriving
    }, null, 8, ["icon", "onClick"]), _createVNode(_component_van_grid_item, {
      class: "invite",
      icon: require('@/assets/icon/menu/invite.svg'),
      text: "邀请好友"
    }, null, 8, ["icon"])]),
    _: 1
  })])) : _createCommentVNode("", true), _hoisted_26])])), [[_directive_height_animate]])]), _createVNode(_component_van_popup, {
    show: $setup.showReserveForm,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $setup.showReserveForm = $event),
    closeable: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_reserve_form, {
      "reserve-day": $setup.reserveDay,
      "reserve-now-click": $options.reserveNowClick,
      "reserve-enter-click": $options.reserveEnterClick
    }, null, 8, ["reserve-day", "reserve-now-click", "reserve-enter-click"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showProxyForm,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => $setup.showProxyForm = $event),
    closeable: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_proxy_form, {
      "passenger-mobile": $setup.proxyPassengerMobile,
      "passenger-name": $setup.proxyPassengerName,
      "priority-contact-passenger": $setup.proxyPriorityContactPassenger,
      "proxy-self-click": $options.proxySelfClick,
      "proxy-enter-click": $options.proxyEnterClick
    }, null, 8, ["passenger-mobile", "passenger-name", "priority-contact-passenger", "proxy-self-click", "proxy-enter-click"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showVoiceForm,
    "onUpdate:show": _cache[10] || (_cache[10] = $event => $setup.showVoiceForm = $event),
    closeable: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_voice_form, {
      adcode: $setup.cityCode,
      "start-address": $setup.startAddress,
      "start-position": $setup.startPosition,
      "enter-callback": $options.voiceEnterCallback
    }, null, 8, ["adcode", "start-address", "start-position", "enter-callback"])]),
    _: 1
  }, 8, ["show"])]);
}